export const protocol_settings_index = ['protocol_settings.index']
export const protocol_settings_create = ['protocol_settings.create']
export const protocol_settings_edit = ['protocol_settings.edit']

export default [].concat(
    protocol_settings_index,
    protocol_settings_create,
    protocol_settings_edit
)
